/* eslint-disable @typescript-eslint/no-explicit-any */
export const registrations = [
    // Global
    {
        name: 'Footer',
        import: () => import('@stories/Widgets/Global/Footer/Footer'),
        config: {
            hydrate: 'in-view',
            blockedByCookiebot: true,
        },
    },
    {
        name: 'GlobalStyles',
        import: () => import('@stories/Widgets/Global/GlobalStyles/GlobalStyles'),
        config: {
            hydrate: 'never',
        },
    },
    {
        name: 'Header',
        import: () => import('@stories/Widgets/Global/Header/Header'),
        config: {
            hydrate: 'always',
            blockedByCookiebot: true,
        },
    },
    // Widgets
    {
        name: 'AccordionList',
        import: () => import('@stories/Widgets/AccordionList/AccordionList'),
        config: {
            hydrate: 'in-view',
            blockedByCookiebot: true,
        },
    },
    {
        name: 'Accolades',
        import: () => import('@stories/Widgets/Accolades/Accolades'),
        config: {
            hydrate: 'in-view',
            blockedByCookiebot: true,
        },
    },
    {
        name: 'CostBenefitsCards',
        import: () => import('@stories/Widgets/CostBenefitsCards/CostBenefitsCards'),
        config: {
            hydrate: 'in-view',
            blockedByCookiebot: true,
        },
    },
    {
        name: 'CtaCardBlock',
        import: () => import('@stories/Widgets/CtaCardBlock/CtaCardBlock'),
        config: {
            hydrate: 'in-view',
            blockedByCookiebot: true,
        },
    },
    {
        name: 'DtwAssistant',
        import: () => import('@stories/Widgets/DtwAssistant/DtwAssistant'),
        config: {
            hydrate: 'eager',
        },
    },
    {
        name: 'ErrorBanner',
        import: () => import('@stories/Widgets/ErrorBanner/ErrorBanner'),
        config: {
            hydrate: 'in-view',
            blockedByCookiebot: true,
        },
    },
    {
        name: 'EventsListing',
        import: () => import('@stories/Widgets/EventsListing/EventsListing'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'ExploreTheForum',
        import: () => import('@stories/Widgets/ExploreTheForum/ExploreTheForum'),
        config: {
            hydrate: 'in-view',
            blockedByCookiebot: true,
        },
    },
    {
        name: 'HeroAndCtaBannerItem',
        import: () => import('@stories/Widgets/HeroAndCtaBanner/HeroAndCtaBanner'),
        config: {
            hydrate: 'in-view',
            blockedByCookiebot: true,
        },
    },
    {
        name: 'HeroBannerInner',
        import: () => import('@stories/Widgets/HeroBannerInner/HeroBannerInner'),
        config: {
            hydrate: 'in-view',
            blockedByCookiebot: true,
        },
    },
    {
        name: 'HeroHomepageBanner',
        import: () => import('@stories/Widgets/HeroHomepageBanner/HeroHomepageBanner'),
        config: {
            hydrate: 'in-view',
            blockedByCookiebot: true,
        },
    },
    {
        name: 'InPersonEventHero',
        import: () => import('@stories/Widgets/InPersonEventHero/InPersonEventHero'),
        config: {
            hydrate: 'in-view',
            blockedByCookiebot: true,
        },
    },
    {
        name: 'HotspotImage',
        import: () => import('@stories/Widgets/HotspotImage/HotspotImage'),
        config: {
            hydrate: 'in-view',
            blockedByCookiebot: true,
        },
    },
    {
        name: 'KenticoForm',
        import: () => import('@stories/Components/Misc/Forms/KenticoForm/KenticoForm'),
        config: {
            hydrate: 'always',
            blockedByCookiebot: true,
        },
    },
    {
        name: 'FeatureBlock',
        import: () => import('@stories/Widgets/FeatureBlock/FeatureBlock'),
        config: {
            hydrate: 'in-view',
            blockedByCookiebot: true,
        },
    },
    {
        name: 'AnimatedNumberCounter',
        import: () => import(/* webpackChunkName: 'AnimatedNumberCounter' */ '@stories/Widgets/AnimatedNumberCounter/AnimatedNumberCounter'),
        config: {
            hydrate: 'in-view',
            blockedByCookiebot: true,
        },
    },
    {
        name: 'CtaCardBlock',
        import: () => import('@stories/Widgets/CtaCardBlock/CtaCardBlock'),
        config: {
            hydrate: 'in-view',
            blockedByCookiebot: true,
        },
    },
    {
        name: 'LatestNews',
        import: () => import('@stories/Widgets/LatestNews/LatestNews'),
        config: {
            hydrate: 'in-view',
            blockedByCookiebot: true,
        },
    },
    {
        name: 'Leaderboard',
        import: () => import('@stories/Widgets/Leaderboard/Leaderboard'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'LogoListing',
        import: () => import('@stories/Widgets/LogoListing/LogoListing'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'MissionCards',
        import: () => import('@stories/Widgets/MissionCards/MissionCards'),
        config: {
            hydrate: 'in-view',
            blockedByCookiebot: true,
        },
    },
    {
        name: 'MicrositeHeader',
        import: () => import('@stories/Widgets/MicrositeHeader/MicrositeHeader'),
        config: {
            hydrate: 'in-view',
            blockedByCookiebot: true,
        },
    },
    {
        name: 'OverviewCardsAndBenefitCards',
        import: () => import('@stories/Widgets/OverviewCardsAndBenefitCards/OverviewCardsAndBenefitCards'),
        config: {
            hydrate: 'in-view',
            blockedByCookiebot: true,
        },
    },
    {
        name: 'PhotoGallery',
        import: () => import('@stories/Widgets/PhotoGallery/PhotoGallery'),
        config: {
            hydrate: 'in-view',
            blockedByCookiebot: true,
        },
    },
    {
        name: 'PressCoverage',
        import: () => import('@stories/Widgets/PressCoverage/PressCoverage'),
        config: {
            hydrate: 'in-view',
            blockedByCookiebot: true,
        },
    },
    {
        name: 'PressReleases',
        import: () => import('@stories/Widgets/PressReleases/PressReleases'),
        config: {
            hydrate: 'in-view',
            blockedByCookiebot: true,
        },
    },
    {
        name: 'RelatedContent',
        import: () => import('@stories/Widgets/RelatedContent/RelatedContent'),
        config: {
            hydrate: 'always',
        },
    },
    {
        name: 'RichText',
        import: () => import('@stories/Widgets/RichText/RichText'),
        config: {
            hydrate: 'in-view',
            blockedByCookiebot: true,
        },
    },
    {
        name: 'RichTextWithSideNavigation',
        import: () => import('@stories/Widgets/RichTextWithSideNavigation/RichTextWithSideNavigation'),
        config: {
            hydrate: 'in-view',
            blockedByCookiebot: true,
        },
    },
    {
        name: 'SitewideAssistant',
        import: () => import('@stories/Widgets/SitewideAssistant/SitewideAssistant'),
        config: {
            hydrate: 'eager',
        },
    },
    {
        name: 'SearchBar',
        import: () => import('@stories/Widgets/SearchBar/SearchBar'),
        config: {
            hydrate: 'in-view',
            blockedByCookiebot: true,
        },
    },
    {
        name: 'SearchResults',
        import: () => import('@stories/Widgets/SearchResults/SearchResults'),
        config: {
            hydrate: 'always',
            blockedByCookiebot: true,
        },
    },
    {
        name: 'SpeakerDetails',
        import: () => import('@stories/Widgets/SpeakerDetails/SpeakerDetails'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'SpeakerHeroBanner',
        import: () => import('@stories/Widgets/SpeakerHeroBanner/SpeakerHeroBanner'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'Testimonial',
        import: () => import('@stories/Widgets/Testimonial/Testimonial'),
        config: {
            hydrate: 'in-view',
            blockedByCookiebot: true,
        },
    },
    {
        name: 'TestimonialSlider',
        import: () => import('@stories/Widgets/TestimonialSlider/TestimonialSlider'),
        config: {
            hydrate: 'in-view',
            blockedByCookiebot: true,
        },
    },
    {
        name: 'VideoImage',
        import: () => import('@stories/Widgets/VideoImage/VideoImage'),
        config: {
            hydrate: 'in-view',
            blockedByCookiebot: true,
        },
    },
    {
        name: 'Process',
        import: () => import('@stories/Widgets/Process/Process'),
        config: {
            hydrate: 'never',
        },
    },
    {
        name: 'SuperSkinnyBanner',
        import: () => import('@stories/Widgets/SuperSkinnyBanner/SuperSkinnyBanner'),
        config: {
            hydrate: 'never',
        },
    },
    {
        name: 'SlimBanner',
        import: () => import('@stories/Widgets/SlimBanner/SlimBanner'),
        config: {
            hydrate: 'in-view',
            blockedByCookiebot: true,
        },
    },
    {
        name: 'CostBenefitsCards',
        import: () => import('@stories/Widgets/CostBenefitsCards/CostBenefitsCards'),
        config: {
            hydrate: 'in-view',
            blockedByCookiebot: true,
        },
    },
    {
        name: 'PricingTimeline',
        import: () => import('@stories/Widgets/PricingTimeline/PricingTimeline'),
        config: {
            hydrate: 'in-view',
            blockedByCookiebot: true,
        },
    },
    {
        name: 'EventSpeakerCards',
        import: () => import('@stories/Widgets/EventSpeakerCards/EventSpeakerCards'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'PeopleBlock',
        import: () => import('@stories/Widgets/PeopleBlock/PeopleBlock'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'PeopleListing',
        import: () => import('@stories/Widgets/PeopleListing/PeopleListing'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'FeaturedCompanies',
        import: () => import('@stories/Widgets/FeaturedCompanies/FeaturedCompanies'),
        config: {
            hydrate: 'always',
        },
    },
    {
        name: 'MarketoForm',
        import: () => import('@stories/Components/Misc/Forms/MarketoForm/MarketoForm'),
        config: {
            hydrate: 'never',
        },
    },
    {
        name: 'HeroVideoBanner',
        import: () => import('@stories/Widgets/HeroVideoBanner/HeroVideoBanner'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'AdvertBanner',
        import: () => import('@stories/Widgets/AdvertBanner/AdvertBanner'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'AgendaList',
        import: () => import('@stories/Widgets/AgendaList/AgendaList'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'FeaturedAgenda',
        import: () => import('@stories/Widgets/FeaturedAgenda/FeaturedAgenda'),
        config: {
            hydrate: 'in-view',
        },
    },
    // My Profile pages (ViewComponent pages — always hydrate since they are auth-gated)
    {
        name: 'MyProfileSettings',
        import: () => import('@stories/Widgets/MyProfile/MyProfileSettings/MyProfileSettings'),
        config: {
            hydrate: 'always',
        },
    },
    {
        name: 'MyProfileBio',
        import: () => import('@stories/Widgets/MyProfile/MyProfileBio/MyProfileBio'),
        config: {
            hydrate: 'always',
        },
    },
    {
        name: 'MyProfileProgress',
        import: () => import('@stories/Widgets/MyProfile/MyProfileProgress/MyProfileProgress'),
        config: {
            hydrate: 'always',
        },
    },
    {
        name: 'CourseListing',
        import: () => import('@stories/Widgets/CourseListing/CourseListing'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'FeaturedCourses',
        import: () => import('@stories/Widgets/FeaturedCourses/FeaturedCourses'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'Author',
        import: () => import('@stories/Widgets/Author/Author'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'CatalystProjectListing',
        import: () => import('@stories/Widgets/CatalystProjectListing/CatalystProjectListing'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'CatalystDetailPageContent',
        import: () => import('@stories/Widgets/CatalystDetailPageContent/CatalystDetailPageContent'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'CatalystProjectBackEnd',
        import: () => import('@stories/Widgets/CatalystProjectBackEnd/CatalystProjectBackEnd'),
        config: {
            hydrate: 'eager',
        },
    },
];
